import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Helmet } from 'react-helmet-async';
const SEO = ({ title = 'BuzBiz | Software Oriented Solutions - Digital Business Automation', description = 'Secure, compliant AI for your business. BuzBiz provides AI implementation, secure workflow automation, AI compliance readiness for California law firms, and cybersecurity to eliminate manual work and accelerate productivity.', keywords = 'business automation, software development, AI implementation, workflow automation, AI compliance, SB 574, cybersecurity, custom software, digital transformation, workflow automation, business process integration', image = 'https://buzbiz.com/images/BuzBiz-h-bg-v2.png', url = 'https://buzbiz.com', type = 'website', }) => {
    const siteName = 'BuzBiz Digital Business Solutions';
    const twitterHandle = '@buzbiz';
    // Structured Data - Organization
    const organizationSchema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'BuzBiz Digital Business Solutions',
        url: 'https://buzbiz.com',
        logo: 'https://buzbiz.com/images/BuzBiz-h-bg-v2.png',
        contactPoint: {
            '@type': 'ContactPoint',
            telephone: '+1-650-485-3370',
            contactType: 'Customer Service',
            email: 'info@buzbiz.com',
            areaServed: 'US',
            availableLanguage: 'English',
        },
        sameAs: [
        // Add social media links when available
        ],
    };
    // Structured Data - LocalBusiness
    const localBusinessSchema = {
        '@context': 'https://schema.org',
        '@type': 'ProfessionalService',
        name: 'BuzBiz Digital Business Solutions',
        image: 'https://buzbiz.com/images/BuzBiz-h-bg-v2.png',
        '@id': 'https://buzbiz.com',
        url: 'https://buzbiz.com',
        telephone: '+1-650-485-3370',
        email: 'info@buzbiz.com',
        address: {
            '@type': 'PostalAddress',
            addressCountry: 'US',
        },
        priceRange: '$$',
        description: description,
    };
    // Structured Data - WebSite
    const websiteSchema = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: siteName,
        url: 'https://buzbiz.com',
        potentialAction: {
            '@type': 'SearchAction',
            target: {
                '@type': 'EntryPoint',
                urlTemplate: 'https://buzbiz.com/?q={search_term_string}',
            },
            'query-input': 'required name=search_term_string',
        },
    };
    // Structured Data - Service Offerings
    const serviceSchema = {
        '@context': 'https://schema.org',
        '@type': 'Service',
        serviceType: 'Business Automation and Software Development',
        provider: {
            '@type': 'Organization',
            name: 'BuzBiz Digital Business Solutions',
        },
        areaServed: {
            '@type': 'Country',
            name: 'United States',
        },
        hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: 'BuzBiz Services',
            itemListElement: [
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'AI Compliance (SB 574 Readiness)',
                        description: 'AI compliance audit, implementation and retainer for California law firms under SB 574 and the State Bar COPRAC guidance',
                    },
                },
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'AI Implementation',
                        description: 'Secure and compliant AI workflow automation with documented data handling and human review',
                    },
                },
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'Cyber Security',
                        description: 'Comprehensive cybersecurity solutions to safeguard data, systems, and reputation',
                    },
                },
            ],
        },
    };
    return (_jsxs(Helmet, { children: [_jsx("title", { children: title }), _jsx("meta", { name: "title", content: title }), _jsx("meta", { name: "description", content: description }), _jsx("meta", { name: "keywords", content: keywords }), _jsx("meta", { name: "author", content: "BuzBiz Digital Business Solutions" }), _jsx("meta", { name: "robots", content: "index, follow" }), _jsx("meta", { name: "language", content: "English" }), _jsx("meta", { name: "revisit-after", content: "7 days" }), _jsx("link", { rel: "canonical", href: url }), _jsx("meta", { property: "og:type", content: type }), _jsx("meta", { property: "og:url", content: url }), _jsx("meta", { property: "og:title", content: title }), _jsx("meta", { property: "og:description", content: description }), _jsx("meta", { property: "og:image", content: image }), _jsx("meta", { property: "og:site_name", content: siteName }), _jsx("meta", { property: "og:locale", content: "en_US" }), _jsx("meta", { name: "twitter:card", content: "summary_large_image" }), _jsx("meta", { name: "twitter:url", content: url }), _jsx("meta", { name: "twitter:title", content: title }), _jsx("meta", { name: "twitter:description", content: description }), _jsx("meta", { name: "twitter:image", content: image }), twitterHandle && _jsx("meta", { name: "twitter:creator", content: twitterHandle }), twitterHandle && _jsx("meta", { name: "twitter:site", content: twitterHandle }), _jsx("meta", { name: "theme-color", content: "#ffbb00" }), _jsx("meta", { name: "msapplication-TileColor", content: "#ffbb00" }), _jsx("meta", { name: "apple-mobile-web-app-capable", content: "yes" }), _jsx("meta", { name: "apple-mobile-web-app-status-bar-style", content: "black-translucent" }), _jsx("meta", { name: "apple-mobile-web-app-title", content: "BuzBiz" }), _jsx("script", { type: "application/ld+json", children: JSON.stringify(organizationSchema) }), _jsx("script", { type: "application/ld+json", children: JSON.stringify(localBusinessSchema) }), _jsx("script", { type: "application/ld+json", children: JSON.stringify(websiteSchema) }), _jsx("script", { type: "application/ld+json", children: JSON.stringify(serviceSchema) })] }));
};
export default SEO;
